import { __read } from "tslib";
import { useCallback, useLayoutEffect, useMemo, useState, } from 'react';
import { useDebouncedCallback } from 'use-debounce';
export function useScrollRender(isActive, topOffset, anchorElement, scrollContentRef) {
    var _a = __read(useState({}), 2), updateState = _a[1];
    var forceUpdate = useCallback(function () { return updateState({}); }, []);
    var _b = __read(useState(false), 2), elementOffScreen = _b[0], setElementOffScreen = _b[1];
    var scrollElement = useMemo(function () { return scrollContentRef === null || scrollContentRef === void 0 ? void 0 : scrollContentRef.current; }, [scrollContentRef]);
    var scrollFuncImpl = useCallback(function () {
        if (!scrollElement || !isActive() || !anchorElement) {
            setElementOffScreen(false);
            return;
        }
        var rect = anchorElement.getBoundingClientRect();
        if (rect.top < -topOffset) {
            setElementOffScreen(true);
        }
        else {
            setElementOffScreen(false);
            forceUpdate();
        }
    }, [
        scrollElement,
        topOffset,
        setElementOffScreen,
        isActive,
        anchorElement,
        forceUpdate,
    ]);
    var scrollFunc = useDebouncedCallback(function () {
        scrollFuncImpl();
    }, 10);
    useLayoutEffect(function () {
        if (!scrollElement || !isActive()) {
            return;
        }
        scrollElement.addEventListener('scroll', scrollFunc);
        scrollElement.addEventListener('resize', scrollFunc);
        return function () {
            scrollElement.removeEventListener('scroll', scrollFunc);
            scrollElement.removeEventListener('resize', scrollFunc);
        };
    }, [scrollElement, scrollFunc, isActive]);
    return elementOffScreen;
}
//# sourceMappingURL=useScrollRender.js.map